import React from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import Login from "../../auth/Login";
import DetailsPage from "./DetailsPage";
const DetailsIndex = () => {
  return (
    <div>
      <AuthenticatedTemplate>
        <DetailsPage />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </div>
  );
};

export default DetailsIndex;
